import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  // Account-portal users must not use the admin console.
  if (auth.isAccount()) {
    return router.createUrlTree(['/portal']);
  }

  return true;
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/login']);
  }

  if (auth.isAdmin()) {
    return true;
  }

  if (auth.isAccount()) {
    return router.createUrlTree(['/portal']);
  }

  return router.createUrlTree(['/journey']);
};

export const portalGuard: CanActivateFn = () => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return router.createUrlTree(['/partner/login']);
  }

  if (auth.isAdmin() || auth.hasRole('account')) {
    return true;
  }

  return router.createUrlTree(['/journey']);
};

export const guestGuard: CanActivateFn = (route) => {
  const auth = inject(AuthSessionService);
  const router = inject(Router);

  if (!auth.isAuthenticated()) {
    return true;
  }

  if (auth.isAdmin()) {
    return router.createUrlTree(['/admin']);
  }

  if (auth.isAccount()) {
    return router.createUrlTree(['/portal']);
  }

  const returnUrl = route.queryParamMap.get('returnUrl');
  if (returnUrl && !returnUrl.startsWith('/learner/login')) {
    return router.parseUrl(returnUrl);
  }

  return router.createUrlTree(['/journey']);
};

export const defaultLandingRedirect = () => {
  const auth = inject(AuthSessionService);
  if (!auth.isAuthenticated()) {
    return '/learner/login';
  }
  if (auth.isAdmin()) {
    return '/admin';
  }
  if (auth.isAccount()) {
    return '/portal';
  }
  return '/journey';
};
